import { render, staticRenderFns } from "./AwardBatchcgf.vue?vue&type=template&id=5abcf9f0&scoped=true"
import script from "./AwardBatchcgf.vue?vue&type=script&lang=js"
export * from "./AwardBatchcgf.vue?vue&type=script&lang=js"
import style0 from "./AwardBatchcgf.vue?vue&type=style&index=0&id=5abcf9f0&prod&lang=css"
import style1 from "./AwardBatchcgf.vue?vue&type=style&index=1&id=5abcf9f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abcf9f0",
  null
  
)

export default component.exports